import { NgModule } from "@angular/core"
import { Route, RouterModule, UrlMatchResult, UrlSegment, UrlSegmentGroup } from "@angular/router"
import { Routes } from "@angular/router"

import { BrowsingComponent } from "./browsing.component"
import { SubjectsGuard } from "../guards/Subjects.guard"

export function customMatcher(
    segments: UrlSegment[],
    group: UrlSegmentGroup,
    route: Route
): UrlMatchResult {
    const nodeSlug: string = segments.map((segment: UrlSegment) => segment.path).join("/")
    const nodeSlugSegment: UrlSegment = new UrlSegment(nodeSlug, { nodeSlug: nodeSlug })
    return { consumed: segments, posParams: { nodeSlug: nodeSlugSegment } }
}

const browsingRoutes: Routes = [
    {
        matcher: customMatcher,
        component: BrowsingComponent,
        canActivate: [SubjectsGuard],
    },
]

@NgModule({
    imports: [RouterModule.forChild(browsingRoutes)],
    exports: [RouterModule],
})
export class BrowsingRoutingModule {}
